// Permisos Qualita relevantes para Facturación Ágil (formato <accion>_<recurso>).
// El backend valida @HasPermission por endpoint; estos son los que el rol
// "Facturación Ágil" debe tener (ver PLAN-IMPLEMENTACION.md, Fase 7).
//
// VERIFICADO EN VIVO (GET /authorization/principal -> {permisos:[...1976]}, 2026-06-25):
// los permisos de recurso son PLURALES (index_clientes, create_clientes), NO singulares.
// comprobanteventaagil / index_comprobanteventa / create_comprobanteventa / update_comprobanteventa
// SÍ existen en singular (son sobre el recurso "comprobanteventa", que ya es la palabra base).
export const PERM = {
  FACTURACION_AGIL: 'comprobanteventaagil',
  COMPROBANTE_INDEX: 'index_comprobanteventa',
  COMPROBANTE_CREATE: 'create_comprobanteventa',
  COMPROBANTE_UPDATE: 'update_comprobanteventa',
  CLIENTE_INDEX: 'index_clientes',
  CLIENTE_CREATE: 'create_clientes',
}

export function hasPermission(permissions, perm) {
  if (!permissions) return false
  return permissions.indexOf(perm) >= 0
}
